import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PendingBranch } from '@features/dashboard/interfaces/pending-branch.interface';
import { TableModule } from "primeng/table";
import { NestedPropertyPipe } from 'src/app/shared/pipes/nested-property.pipe';
import { DatePicker } from "primeng/datepicker";
import { FormsModule } from '@angular/forms';
import { DatesService } from '@features/reports/components/dates-filter/dates.service';
import { Field } from '@features/reports/cash-closing-report/interfaces/column.interface';

@Component({
    selector: 'app-branches-differences-table',
    imports: [CommonModule, FormsModule, TableModule, NestedPropertyPipe, DatePicker],
    templateUrl: './branches-differences-table.component.html',
})
export class BranchesDifferencesTableComponent {

    filterDatesService = inject(DatesService);
    private router = inject(Router);
    private route = inject(ActivatedRoute);

    pendingBranches = input.required<PendingBranch[]>();

    readonly columns: Field[] = [
        { field: 'key', header: 'Clave' },
        { field: 'branch.centro', header: 'Centro' },
        { field: 'branch.descripcion_centro', header: 'Sucursal' },
        { field: 'total_branch_closing', header: 'Total Esperado', isImport: true },
        { field: 'total_cash_register_cut', header: 'Total Recibido', isImport: true },
        { field: 'difference', header: 'Diferencia', isImport: true },
    ];

    hasDifference(row: PendingBranch): boolean {
        return Number(row.difference ?? 0) !== 0;
    }

    get selectedDate(): Date | null {
        const dates = this.filterDatesService.datesAsObjects();
        return dates.length > 0 ? dates[0] : new Date();
    }

    onDateChange(newDate: Date): void {
        if (!newDate) return;

        const year = newDate.getFullYear();
        const month = String(newDate.getMonth() + 1).padStart(2, '0');
        const day = String(newDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { dates: formattedDate },
            queryParamsHandling: 'merge',
        });
    }
}
